import React from 'react';
import { Modal, Box, Typography, Button, List, ListItem } from '@mui/material';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" gutterBottom>
          🖨️ Welcome to the Label Generator!
        </Typography>
        <Typography variant="body1" gutterBottom>
          Quickly generate a printable PDF set of QR code labels with markdown-formatted text beside each code.
        </Typography>
        <List dense>
          <ListItem>✅ Add new labels using <strong>"Add New Entry"</strong></ListItem>
          <ListItem>📥 Export and import your label sets for future reuse</ListItem>
          <ListItem>🖨️ Click <strong>"PDF"</strong> to generate your printable labels</ListItem>
        </List>
        <Button variant="contained" fullWidth onClick={onClose} sx={{ mt: 2 }}>
          Got it!
        </Button>
      </Box>
    </Modal>
  );
};

export default WelcomeModal;
